import { fork } from 'redux-saga/effects';
import searchForm from './searchForm/sideEffects';
import lookups from './lookups/sideEffects';
import userRoles from './userRoles/sideEffects';

export function* rootSaga() {
  yield fork(lookups);
  yield fork(searchForm);
  yield fork(userRoles);
}
